<template>
  <span class="krcv" :class="{ empty }">
    <span class="krcv-text">{{ value }}</span>
    <button
      v-if="!empty"
      type="button"
      class="krcv-btn"
      :class="{ done: copied }"
      :title="copied ? 'Kopyalandı' : 'Kopyala'"
      @click.stop="copy"
    >
      <i :class="copied ? 'fa fa-check' : 'fa fa-copy'"></i>
    </button>
  </span>
</template>

<script>
// Detay'da tek bir alan degerini gosterir + hover'da cikan kopyala ikonu ile
// o degeri panoya alir. Kalabalik olmasin diye ikon default gizli, hover'da belirir.
export default {
  name: "krCopyValue",
  props: {
    value: { type: [String, Number], default: "" },
    empty: { type: Boolean, default: false },
  },
  data() {
    return { copied: false, copyTimer: null };
  },
  beforeUnmount() {
    clearTimeout(this.copyTimer);
  },
  methods: {
    copy() {
      // Global yardimciya yonlendirildi: HTTP'de ve izin reddinde artik hata
      // toast'i cikiyor. silentSuccess=true -> basari tik ile gosteriliyor.
      Promise.resolve(
        this.$root.clipboardCopy(String(this.value), true)
      ).then((ok) => {
        if (ok === false) return;
        this.copied = true;
        clearTimeout(this.copyTimer);
        this.copyTimer = setTimeout(() => {
          this.copied = false;
        }, 1200);
      });
    },
  },
};
</script>

<style scoped>
.krcv {
  display: inline-flex;
  align-items: baseline;
  gap: 6px;
  min-width: 0;
}
/* Detay panelinde okunan asil metin. Key'den (12.5px monospace) bir tik buyuk
   ve daha kalin -> key/deger hiyerarsisi net. */
.krcv-text {
  font-size: 15px;
  font-weight: 500;
  line-height: 1.4;
  color: var(--text-primary, #1c1c22);
  word-break: break-word;
}
.krcv.empty .krcv-text {
  color: var(--text-tertiary, #c2c2c9);
}
.krcv-btn {
  flex: 0 0 auto;
  align-self: center;
  width: 22px;
  height: 22px;
  padding: 0;
  border: 0;
  border-radius: 5px;
  background: transparent;
  color: var(--text-tertiary, #a7a7af);
  font-size: 12px;
  line-height: 1;
  cursor: pointer;
  opacity: 0;
  transition: opacity 0.12s ease, color 0.12s ease, background 0.12s ease;
}
.krcv:hover .krcv-btn,
.krcv-btn:focus-visible {
  opacity: 0.7;
}
.krcv-btn:hover {
  opacity: 1;
  /* ikon: #1e88e5 ile 3.29 kontrast -> koyu mavi 4.4 */
  color: var(--color-brand-600, #1565c0);
  background: var(--bg-secondary, #f2f2f5);
}
.krcv-btn.done {
  opacity: 1;
  color: #1a8a55;
}
</style>
